var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquareMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_3998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.43164 0H8.49609C9.43848 0 10.2959 0.386719 10.918 1.00781C11.541 1.62988 11.9277 2.48828 11.9277 3.43164V8.56934C11.9277 9.51074 11.541 10.3682 10.9199 10.9902L10.918 10.9922C10.2949 11.6143 9.4375 12 8.49707 12H3.43164C2.48828 12 1.62988 11.6133 1.00781 10.9922L0.984375 10.9658C0.376953 10.3467 0 9.49902 0 8.56836V3.43164C0 2.4873 0.385742 1.62988 1.00781 1.00781C1.62988 0.385742 2.4873 0 3.43164 0ZM8.93652 3.0293L8.94336 3.04004H11.0527C10.9678 2.48535 10.7031 1.9873 10.3223 1.60547C9.85352 1.13672 9.20703 0.845703 8.49609 0.845703H7.62988L8.93652 3.0293ZM7.96094 3.04004L6.64746 0.845703H3.7666L5.0957 3.04004H7.96094ZM4.1123 3.04004L2.82715 0.916992C2.35742 1.03027 1.93652 1.27344 1.60547 1.60547C1.22461 1.98633 0.960938 2.48535 0.875 3.04004H4.1123V3.04004ZM11.082 3.88574H0.845703V8.56934C0.845703 9.26953 1.12793 9.90723 1.58398 10.374L1.60547 10.3945C2.07422 10.8633 2.72168 11.1553 3.43164 11.1553H8.49609C9.20703 11.1553 9.85352 10.8643 10.3213 10.3965L10.3232 10.3945C10.791 9.92676 11.082 9.28027 11.082 8.56934V3.88574V3.88574ZM4.97559 5.36621L7.5957 7.07031C7.6377 7.09766 7.67578 7.13281 7.70606 7.17578C7.8252 7.34863 7.78125 7.58594 7.6084 7.70508L4.99902 9.24512C4.93359 9.29883 4.84961 9.33105 4.75684 9.33105C4.5459 9.33105 4.375 9.16016 4.375 8.94922V5.67871H4.37695C4.37695 5.60352 4.39941 5.52734 4.44531 5.46094C4.56641 5.28809 4.80371 5.24609 4.97559 5.36621Z",
    fill: "#A3A1AA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_3998"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9277,
    height: 12,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareMini);
export default __webpack_public_path__ + "static/media/squareMini.81da645d.svg";
export { ForwardRef as ReactComponent };